<template>
    <div class="rate-box">
        <div>
            <span>类 型: </span>
            <el-select v-model="queryParams.type">
                <el-option label="全部" value=""></el-option>
                <el-option label="转入" value="0"></el-option>
                <el-option label="转出" value="1"></el-option>
            </el-select>
            <el-input placeholder="请输入用户ID" clearable v-model="queryParams.userId" @keyup.native.enter="handleSearch"
                      style="width: 300px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-autocomplete class="inline-input"
                             v-model="queryParams.coinType"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入挖矿币种"
                             @select="handleSelect"
                             @keyup.native.enter="handleSearch">
                <i class="el-icon-close el-input__icon" slot="suffix"
                   @click="cleanSearchCoin" style="cursor:pointer;">
                </i>
            </el-autocomplete>
            <el-date-picker
                    v-model="dateArr"
                    value-format="timestamp"
                    type="datetimerange"
                    @change="dateChange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间">
            </el-date-picker>
            <el-button type="primary" @click="searchRate">搜索</el-button>
        </div>

        <div class="rate-list">
            <el-table class="rate-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="miningRecord" :row-key="() => Math.random()">
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="coinType" label="挖矿币种"></el-table-column>
                <el-table-column prop="amount" label="数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==0">转入</span>
                        <span v-if="scope.row.type==1">转出</span>
                    </template>
                </el-table-column>
                <el-table-column label="解锁时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.unfreezeTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100, 500, 1000, 2000]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'MiningRecord',
        data() {
            return {
                miningRecord: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10,
                    coinType: "",
                    userId: "",
                    type: "",
                    startTime: "",
                    endTime: ""
                },
                coinTypes: [],
                dateArr: []
            }
        },
        methods: {
            dateChange() {
                this.queryParams.startTime = this.dateArr != null ? this.dateArr[0] : null;
                this.queryParams.endTime = this.dateArr != null ? this.dateArr[1] : null;
            },
            getUserMiningRecord(query) {
                api.getUserMiningRecord(query).then(({data}) => {
                    this.miningRecord = data.list;
                    this.total = data.totalCount;
                });
            },
            searchRate() {
                this.getUserMiningRecord(this.queryParams);
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getUserMiningRecord(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getUserMiningRecord(this.queryParams);
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            handleSearch() {
                this.queryParams.page = 1;
                this.getUserMiningRecord(this.queryParams);
            },
            handleSelect() {
            },
            reflashData() {
                this.getAllSupportCoin();
                this.getUserMiningRecord(this.queryParams);
            }
        },
        created() {
            // this.getAllSupportCoin();
            // this.getUserMiningList(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .rate-box {
        .rate-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .rate-table {
                margin-top: 30px;
            }
        }
    }
</style>
